import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.d1uESJ',
    defaultMessage: 'Assets',
  },
  uploadButton: {
    id: 'studio.2Cqy9n',
    defaultMessage: 'Upload new asset',
  },
  deleteButton: {
    id: 'studio.kS1xTp',
    defaultMessage: 'Delete {amount} {amount, plural, one {asset} other {assets}}',
  },
  id: {
    id: 'studio.kGGU2D',
    defaultMessage: 'Id',
  },
  resource: {
    id: 'studio.wmyg6t',
    defaultMessage: 'Resource',
  },
  mime: {
    id: 'studio.PiZbK/',
    defaultMessage: 'File type',
  },
  filename: {
    id: 'studio.UaS6dK',
    defaultMessage: 'Filename',
  },
  name: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  nameDescription: {
    id: 'studio.Ie7wfA',
    defaultMessage:
      'If a name is set, the asset may be referenced by this name in addition to its ID.',
  },
  actions: {
    id: 'studio.wL7VAE',
    defaultMessage: 'Actions',
  },
  preview: {
    id: 'studio.TJo5E6',
    defaultMessage: 'Preview',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'studio.K3r6DQ',
    defaultMessage: 'Delete',
  },
  deleteWarningTitle: {
    id: 'studio.3CTAH+',
    defaultMessage: 'Deleting {amount} {amount, plural, one {asset} other {assets}}',
  },
  deleteWarning: {
    id: 'studio./T03S3',
    defaultMessage:
      'Are you sure you want to delete {amount} {amount, plural, one {asset} other {assets}}? This action cannot be reverted.',
  },
  deleteSuccess: {
    id: 'studio.WX/z1r',
    defaultMessage: 'Successfully deleted {amount, plural, one {asset} other {assets}} {assets}',
  },
  upload: {
    id: 'studio.p4N05H',
    defaultMessage: 'Upload',
  },
  uploadTitle: {
    id: 'studio.2Cqy9n',
    defaultMessage: 'Upload new asset',
  },
  file: {
    id: 'studio.gyrIEl',
    defaultMessage: 'File',
  },
  chooseFile: {
    id: 'studio.86RD6b',
    defaultMessage: 'Choose file…',
  },
  noFile: {
    id: 'studio.FTFqXw',
    defaultMessage: 'No file chosen',
  },
  uploadSuccess: {
    id: 'studio.brhaBY',
    defaultMessage: 'Successfully uploaded asset {id}',
  },
  uploadError: {
    id: 'studio.+7HI4W',
    defaultMessage: 'There as a problem uploading the asset. Please try again.',
  },
  error: {
    id: 'studio./EEiL0',
    defaultMessage: 'Something went wrong when fetching this app’s assets.',
  },
  loading: {
    id: 'studio.ha50XH',
    defaultMessage: 'Assets are being loaded…',
  },
  empty: {
    id: 'studio.D7b7Dd',
    defaultMessage: 'This app currently has no assets.',
  },
});
